import React from 'react'
import SbEditable from 'storyblok-react'

import Image from './../Image'
import TextRenderer from './../TextRenderer'

import styles from './styles.module.scss'

const StepItem = (props) => {
	return (
		<SbEditable content={props.blok}>
			<div className={styles['step-item']} style={{ color: props.blok.background_color }}>
				{props.blok.icon.filename && (
					<figure className={styles['step-item__icon-wrapper']}>
						<img className={styles['step-item__icon']} src={props.blok.icon.filename} alt={props.blok.icon.alt} />
					</figure>
				)}
				<h4 className={`heading-3 ${styles['step-item__title']}`}>{props.blok.title}</h4>
				<TextRenderer text={props.blok.description} className={styles['step-item__description']} style={{ color: '#000' }} />
			</div>
		</SbEditable>
	)
}

export default StepItem